import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { Guid } from 'guid-typescript';
import { Table } from 'reactstrap';
import Select from 'react-select';
import { Common } from '../../../../core/common';
import Translator from '../../../../core/i18n';
import { Formik, FormikProps } from 'formik';
import { BackgroundService } from '../../../../api/background-service';
import { IAction, IAppState } from '../../../../models/action/core';
import { Course } from '../../../../components/filters/course';
import { Class } from '../../../../components/filters/class';
import { User } from '../../../../components/filters/user';
import { Program } from '../../../../components/filters/program';
import { Unit } from '../../../../components/filters/unit';
import { Notification } from '../../../../components/notification/main';
import Paginate from '../../../../components/table/paginate';
import { ReportService } from '../../../../api/report-services';
import { IAdminReportsProps } from '../../../../models/components/admin-reports-interfaces/IAdminReportsProps';
import { IAdminCourseProgressReportState } from '../../../../models/components/admin-reports-interfaces/IAdminCourseProgressReportState';
import { IAdminCourseProgressReportFormikProps } from '../../../../models/components/admin-reports-interfaces/IAdminCourseProgressReportFormikProps';
import { getValidationAdminCourseProgressReport } from '../../../../models/validations/admin-course-progress-report-validation';
import imgAnn from '../../../../static/images/announcement.svg';
import { Button } from '../../../../components/ui-elements/main';
const T = Translator.create();
let _common: Common;

const _reportService = new ReportService();
const _backgroundService = new BackgroundService();

const options = [
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' }
];

const customStyles: any = {
    control: (styles: any) => ({
        ...styles,
        background: 'white',
        color: 'white',
        boxShadow: 'none',
        borderColor: '#ccc',
        borderWidth: 0,
        borderBottomWidth: 1,
        borderRadius: 0
    })
};

class CourseProgressReport extends React.Component<IAdminReportsProps, IAdminCourseProgressReportState> {
    public state: IAdminCourseProgressReportState = {
        reportData: [],
        isReportShow: false,
        selectedOption: [{ value: 10, label: '10' }],
        _colOrder: '',
        _rowOrder: '',
        _cols: [],
        _rows: [],
        _tempCols: [],
        _tempRows: [
            T.t('r_gen_Admin_report_username'),
            T.t('r_gen_Admin_report_fullname'),
            T.t('r_gen_Admin_report_coursename'),
            T.t('r_gen_Admin_report_classname'),
            T.t('r_gen_Admin_report_completiondate'),
            T.t('r_gen_Admin_report_progress'),
            T.t('r_gen_Admin_report_department'),
            T.t('r_gen_Admin_report_unit')
        ],
        _nameRows: [
            T.t('r_gen_Admin_report_username'),
            T.t('r_gen_Admin_report_fullname'),
            T.t('r_gen_Admin_report_coursename'),
            T.t('r_gen_Admin_report_classname'),
            T.t('r_gen_Admin_report_completiondate'),
            T.t('r_gen_Admin_report_progress'),
            T.t('r_gen_Admin_report_department'),
            T.t('r_gen_Admin_report_unit')
        ],
        submitValues: null,
        isSelected: false,
        filters: {
            page: 1,
            take: 10,
            total: 0
        }
    };
    constructor(props: IAdminReportsProps) {
        super(props);
        this.onDownload = this.onDownload.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        _common = new Common();
    }

    public onChangeTake = (event: any) => {
        const selectedOption = event;
        this.setState(
            (prevState) => ({
                selectedOption,
                filters: { ...prevState.filters, take: event.value }
            }),
            () => {
                this.onSubmit(this.state.submitValues);
            }
        );
    };


    onSubmit = async (values: IAdminCourseProgressReportFormikProps) => {
        this.setState({ isReportShow: true });
        this.setState({ isSelected: true });
        this.setState({ reportData: [] });
        try {
            const tempRowsData = this.state._tempRows.concat(values.rowNameList);
            values.rowNames = tempRowsData;
            this.setState({ submitValues: values });
            values.take = this.state.filters.take;
            values.skip = this.state.filters.skip;
            const reportData = await _reportService.RequestCourseProgressReportData(values);
            const reportJson = await reportData.json();
            this.setState({ reportData: reportJson, formikValues: values });
        } catch {
            Notification.setNotification('error', T.t('r_report_page_get_error_message'), 'topRight');
        }
    };

    onDownload = async () => {
        try {
            const params = this.state.formikValues;
            if (!params) {
                return;
            }

            params.rows = this.state._rows.length > 0 ? this.state._rows : this.state._tempRows;
            params.cols = this.state._cols.length > 0 ? this.state._cols : this.state._tempCols;
            params.colOrder = this.state._colOrder;
            params.rowOrder = this.state._rowOrder;

            const responseData = await _backgroundService.RequestDownloadCourseProgressReportAsync(params);

            const isError = responseData.status !== 200;
            const errorList = isError ? responseData : null;

            this.handleNotifications(isError, errorList);
        } catch (error) {
            Notification.setNotification('error', T.t('r_report_page_get_error_message'), 'topRight');
        }
    };

    handleNotifications = (isError: boolean, errorList: any) => {
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        } else {
            Notification.setNotification(
                'success',
                T.t('r_gen_background_activityReport_pending'),
                'topRight'
            );
        }
    };


    validateAndSubmit = async (formik: FormikProps<IAdminCourseProgressReportFormikProps>) => {
        const validations = await formik.validateForm().then((result: any) => result);
        Object.keys(validations).forEach((validationKey: string) => {
            if (validationKey) {
                Notification.setNotification(
                    'error',
                    T.t('r_validation_report_' + validationKey) + ' - ' + validations[validationKey],
                    'topRight'
                );
            }
        });

        formik.submitForm();
    };
    public onPageChange = (page: number) => {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                page: page
            }
        }), () => {
            this.onSubmit(this.state.submitValues);
        });
    };
    viewTotalRowCount = (totalRowCount: any, dataLength: any) => {
        if (totalRowCount?.length > 0) {
            if (totalRowCount.pop()) {
                return dataLength.reverse()[0];
            } else {
                return 0;
            }
        } else {
            return 0;
        }
    };
    viewData = (data: any) => {
        if (data) {
            return data;
        } else {
            return '-';
        }
    };

    getDataLength = (totalRowCount: any) => {
        if (totalRowCount && totalRowCount.length > 0) {
            if (totalRowCount.pop()) {
                return totalRowCount.pop();
            } else {
                return undefined;
            }
        } else {
            return undefined;
        }
    };

    viewReportTable = (basicReportRows: any, basicReportData: any, totalRowCount: any, dataLength: any) => {
        if (this.state.reportData.length <= 0 && this.state.isReportShow) {
            return (
                <div className="row mt-4 spinner_bg">
                    <div className="donut" />
                    <span className="report_title">{T.t('r_gen_reports_loading')}</span>
                </div>
            );
        } else if (this.state.reportData.length > 1) {
            return (
                <div
                    className="container slideInUp show animated container-rpt "
                    style={this.state.isReportShow ? { display: 'block', maxWidth: 'none', width: '95%' } : { display: 'none' }}
                >
                    <div className="row">
                        <div className="col-md-12">
                            <div
                                className="d-flex justify-content-between student-course-header"
                                style={{ paddingBottom: '10px', paddingTop: 20 }}
                            >
                                <h6 className="mb-3 mb-md-0">{T.t('r_menu_report')}</h6>
                            </div>
                            <div>
                                <div id="basicReportTable" className='report-table-title'>
                                    <Table className="table-user-list table-ellipsis" striped={true} hover={true} borderless={true}>
                                    <thead className='report-table-title-thread'>
                                            <tr>
                                                {this.state.reportData.length > 0
                                                    && basicReportRows.slice(0, -1).map((item: any, index: number) => {
                                                        return (
                                                            <th key={"row_" + item} className='text-center'>
                                                                {this.state._nameRows[index]}
                                                            </th>
                                                        );
                                                    })
                                                }
                                            </tr>
                                    </thead>
                                        <tbody>
                                            {basicReportData.length > 0 &&
                                                basicReportData.splice(1).map((item: any) => {
                                                    return (
                                                        <tr
                                                            key={'student-' + Guid.create.toString()}
                                                            data-title={'title'}
                                                            style={{ cursor: 'initial' }}
                                                        >
                                                            {item.slice(0, -1).map((data: any) => {
                                                                return (
                                                                    <td
                                                                        key={Guid.create.toString()}
                                                                        data-label="label"
                                                                        className="text-center"
                                                                        style={{ whiteSpace: 'break-spaces' }}
                                                                    >
                                                                        {this.viewData(data)}
                                                                    </td>
                                                                );
                                                            })}
                                                        </tr>
                                                    );
                                                })}
                                        </tbody>
                                    </Table>
                                    {this.state.reportData.length > 0 && (
                                        <Paginate
                                            filters={{
                                                skip: this.state.filters.skip,
                                                take: this.state.filters.take,
                                                page: this.state.filters.page,
                                                total: this.viewTotalRowCount(totalRowCount, dataLength)
                                            }}
                                            onPageChange={this.onPageChange}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else if (this.state.isReportShow) {
            return (
                <div className="row mx-0 mt-4 report_info_bg">
                    <div className="d-flex justify-content-start flex-column align-items-center report_info_text  col-12">
                        <img src={_common.GetDefaultIcons('cloud')} alt="cloud" />
                        <h5>{T.t('r_gen_reports_data_not_found')}</h5>
                        <p>{T.t('r_gen_reports_data_not_found_desc')}</p>
                    </div>
                </div>
            );
        } else {
            return (
                <>
                    <img style={{ marginInlineStart: 'calc(50% - 89px)', marginTop: '2em' }} src={imgAnn} alt="" />

                    <h5 className="d-block" style={{ marginTop: 15, textAlign: 'center', marginBottom: 50 }}>
                        {T.t('r_gen_report_not_searched')}
                    </h5>
                </>
            );
        }
    };

    render() {
        const initialFormValues: IAdminCourseProgressReportFormikProps = {
            rowNames: [],
            rowNameList: [],
            selectedCourses: [],
            selectedClasses: [],
            selectedUsers: [],
            selectedPrograms: [],
            selectedUnits: [],
            take: 100,
            termIds: []
        };
        const basicReportData: Array<any> | undefined = [...this.state.reportData];
        const basicReportRows: Array<any> | undefined = [...this.state.reportData].shift();
        const totalRowCount: Array<any> | undefined = this.state.reportData.length > 1 ? [...this.state.reportData] : undefined;
        const dataLength: any = this.getDataLength(totalRowCount);

        return (
            <div>
                <div className="student-course" style={{ paddingBottom: '1em' }}>
                    <div className="question-filter">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-md-4">
                                    <h6 className="mb-3 mb-md-0">{T.t('r_gen_reports_course_progress_report')}</h6>
                                </div>
                                <div className="col-md-8 text-md-right">
                                    <div className="options d-inline-flex align-items-center">

                                        <Button
                                            data-toggle="modal"
                                            data-target="#preview-question"
                                            button_type='primary'
                                            size='medium'
                                            text={T.t('r_gen_download_full_data')}
                                            onClick={this.onDownload}
                                            materialicon='arrow_downward'
                                            iconPosition='left'
                                        />
                                    </div>
                                </div>
                            </div>
                            <Formik initialValues={initialFormValues} validationSchema={getValidationAdminCourseProgressReport()} onSubmit={this.onSubmit}>
                                {formik => {
                                    return (
                                        <form key={'Course_Progress_Report'}>
                                            <div className="filter-fields mt-4">
                                                <div className="row">
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                        <div className="k365-input date-picker">
                                                        <label className='input-label'>{T.t('r_gen_user_select')}</label>
                                                            <User
                                                                    formik={formik}
                                                                    value={formik.values.selectedUsers}
                                                                    errors={formik.errors.selectedUsers}
                                                                    touched={formik.touched.selectedUsers}
                                                                    name={'selectedUsers'}
                                                                    courseIds={formik.values.selectedCourses}
                                                                    classIds={formik.values.selectedClasses}
                                                                    unitIds={formik.values.selectedUnits}
                                                                    programIds={formik.values.selectedPrograms}
                                                                />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                        <div className="k365-input date-picker">
                                                            <label className='input-label'>{T.t('r_gen_class_select')}</label>
                                                            <Class
                                                                formik={formik}
                                                                value={formik.values.selectedClasses}
                                                                errors={formik.errors.selectedClasses}
                                                                touched={formik.touched.selectedClasses}
                                                                name={'selectedClasses'}
                                                                courseIds={formik.values.selectedCourses}
                                                                unitIds={formik.values.selectedUnits}
                                                                programIds={formik.values.selectedPrograms}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                        <div className="k365-input date-picker">
                                                            <label className='input-label'>{T.t('r_gen_course_select')}</label>
                                                            <Course
                                                                formik={formik}
                                                                value={formik.values.selectedCourses}
                                                                errors={formik.errors.selectedCourses}
                                                                touched={formik.touched.selectedCourses}
                                                                name={'selectedCourses'}
                                                                unitIds={formik.values.selectedUnits}
                                                                programIds={formik.values.selectedPrograms}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                        <div className="k365-input date-picker">
                                                            <label className='input-label'>{T.t('r_gen_program_select')}</label>
                                                            <Program
                                                                formik={formik}
                                                                value={formik.values.selectedPrograms}
                                                                errors={formik.errors.selectedPrograms}
                                                                touched={formik.touched.selectedPrograms}
                                                                name={'selectedPrograms'}
                                                                unitIds={formik.values.selectedUnits}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                        <div className="k365-input date-picker">
                                                            <label className='input-label'>{T.t('r_gen_unit_select')}</label>
                                                            <Unit
                                                                formik={formik}
                                                                value={formik.values.selectedUnits}
                                                                errors={formik.errors.selectedUnits}
                                                                touched={formik.touched.selectedUnits}
                                                                name={'selectedUnits'}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6 "></div>
                                                    {this.state.isSelected && (
                                                        <div className="col">
                                                            <div className=" d-flex flex-row">
                                                            <div className='k365-input' style={{ width: '40%' }}>
                                                                    <label className='input-label'>{T.t('r_data_per_page')}</label>
                                                                    <Select
                                                                        className='k365-select'
                                                                        options={options}
                                                                        value={this.state.selectedOption}
                                                                        onChange={this.onChangeTake}
                                                                        styles={customStyles}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className="col">
                                                        <div className="ml-auto text-right mx-3 mb-2">
                                                            <Button
                                                                button_type='primary'
                                                                size='medium'
                                                                onClick={this.validateAndSubmit.bind(this, formik)}
                                                                text={T.t('r_gen_search')}
                                                                materialicon='search'
                                                                iconPosition='left'
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    );
                                }}
                            </Formik>
                            <div className="question-list mt-3">
                                <div className="info-box">
                                    <p>
                                        {T.t('r_gen_course_progress_reports_info')}
                                        {T.t('r_gen_reports_info_new_start')}
                                        <b>{T.t('r_gen_download_full_data')}</b> {T.t('r_gen_reports_info_end')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.viewReportTable(basicReportRows, basicReportData, totalRowCount, dataLength)}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IAdminReportsProps): IAdminReportsProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IAdminReportsProps = {
        ...ownProps,
        userPreferences: state.profile.userPreferences.preferences,
        culture: state.login.identitiy.culture,
    };

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.profile.userPreferences === prev.profile.userPreferences;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CCourseProgressReport = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(CourseProgressReport);

export default CCourseProgressReport;
